module.exports = __webpack_public_path__ + "static/willow-square-27fb89c15b50206d82d398d2fc6f0645.jpg";